import burger from "./modules/burger";
import tabs from "./modules/tabs";
import { openModal } from "./modules/modal";
import modal from "./modules/modal";
import forms from "./modules/forms";
import smoothScroll from "./modules/smooth-scroll";
import video from "./modules/video";
import feedbacksLogopedOnlineArr from "./data/feedbacksLogopedOnlineArr";
import feedbacks from './modules/feedbacks';
import faqMaterialsArr from "./data/faqMaterialsArr";
import slider from "./modules/slider";
import { accordionStatic } from "./modules/accordion";
import { smartMessengersHandler } from "./modules/smartMessengersHandler";

window.addEventListener('DOMContentLoaded', () => {
    const modalTimerId = setTimeout(() => {
        openModal(
            '.modal',
            modalTimerId,
            undefined,
            true
        );
    }, 120000);

    tabs('.tabheader__item', '.tabcontent', '.tabheader__items', 'tabheader__item_active');
    accordionStatic(
        '.faq__descr',
        '.faq__btn',
        '.faq__wrapper'
    );
    modal('[data-modal]', '.modal', modalTimerId);
    forms('#form', modalTimerId);
    burger({
        menuSelector: '.header__menu',
        menuItemSelector: '.header__item',
        hamburgerSelector: '.hamburger',
        menuSelectorActive: 'header__menu_active',
        hamburgerSelectorActive: 'hamburger_active'
    });
    video('.video__speechtherapist');
    feedbacks('#feedback-row', 'button[data-more-feedbacks-2]', 'button_disabled', feedbacksLogopedOnlineArr);
    smoothScroll('.pageup', 500);
    // slider('.carousel__inner');
    smartMessengersHandler();
});